<template>
    <div>
        <div class="form-group ">
            <label>Ruolo:</label>
            <select class="form-control" v-model="item_role" >
                <option v-for="(row) in this.roles" :value="row.id">
                    {{row.name}}
                </option>
            </select>
        </div>

        <div class="form-group ">
            <label>Orizzonte tempororale</label>
            <input class="form-control" type="number" min="1" max="10" v-model="item_horizontal_temp">
        </div>

        <button class="btn btn--green" type="button" @click="goToUrl()"> Invia </button>
    </div>
</template>

<script>

  export default {
    // <multiselect v-model="value" :options="options"></multiselect>
    // OR register locally
    //components: { Multiselect },
    data () {
        return {

            item_role : null,
            item_horizontal_temp : null,

        }
    },
    methods: {
        goToUrl(){
            window.location.href="/compensations-dynamics/"+this.chart_id+"?role="+this.item_role+"&horizontal_temp="+this.item_horizontal_temp;
        }
    },
    mounted() {
        this.item_role = this.role_id;
        this.item_horizontal_temp = this.horizontal_temp;
    },
    props: {

        chart_id: {
            type: Number,
            required: false,
            default:null,
        },
        role_id: {
            type: Number,
            required: false,
            default:null,
        },
        roles:{
            type : Object,
            required: true
        },
        horizontal_temp: {
            type: Number,
            required: true,

        },
    }

  }
</script>

<style>
	.hidden {
		display: none;
	}


</style>
